import { SvgStyled } from '../../../components/Global/Atomics/SvgStyled';

const AwfulSmile = (props) => {
    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 64 64"
            fill={props.fill ? props.fill : 'none'}
            width={props.size}
            height={props.size}>
            <path fillRule="evenodd" clipRule="evenodd" d="M32.5 4.0625C16.7944 4.0625 4.0625 16.7944 4.0625 32.5C4.0625 48.2056 16.7944 60.9375 32.5 60.9375C48.2056 60.9375 60.9375 48.2056 60.9375 32.5C60.9375 16.7944 48.2056 4.0625 32.5 4.0625ZM0 32.5C0 14.5507 14.5507 0 32.5 0C50.4493 0 65 14.5507 65 32.5C65 50.4493 50.4493 65 32.5 65C14.5507 65 0 50.4493 0 32.5Z" 
            fill={props.color ? props.color : "white"}  />
            <path d="M22.3438 42.6562C22.3438 42.6562 24.375 47.7344 32.5 47.7344C40.625 47.7344 42.6562 42.6563 42.6562 42.6563" stroke={props.color ? props.color : "white"}  strokeWidth="2" strokeLinecap="round" />
            <rect x="38.5938" y="18.2812" width="8.125" height="8.125" rx="4.0625" fill={props.color ? props.color : "white"}  />
            <rect x="18.2812" y="18.2812" width="8.125" height="8.125" rx="4.0625" fill={props.color ? props.color : "white"}  />
        </SvgStyled>
    );
};

export default AwfulSmile;
